import * as React from 'react';
import { Field, Form, Formik } from 'formik';
import { Autocomplete } from '../Autocomplete/Autocomplete';
import { getFullName, searchFunctionMergeableUsers } from 'Src/helpers/autocomplete/autocomplete';
import { AppUser } from 'Src/views/App/App';
import {
  getName,
  searchFunctionSchoolFormsPublic,
  searchFunctionSchoolHousesPublic
} from '../../helpers/autocomplete/autocomplete';
import { ROLE } from '../../consts/user';

interface Props {
  onCloseClick: () => void;
  onAcceptClick: (values) => void;
  request: any;
  user: AppUser;
}

interface State {
  formId: string;
  houseId: string;
}

export class AcceptAndMergeRequestForm extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      formId: '',
      houseId: ''
    };
  }

  getUser = (text: string, setFieldValue) => {
    const { user } = this.props;
    const { formId } = this.state;
    const { houseId } = this.state;
    if (text === '') {
      setFieldValue('userId', '');
      setFieldValue('user', undefined);
    }
    return searchFunctionMergeableUsers(user, text, this.props.request.requestedPermission, formId, houseId);
  };

  getSchoolForms = (text: string, setFieldValue) => {
    if (text === '') {
      setFieldValue('formId', '');
      setFieldValue('form', undefined);
      this.setState({ formId: '' });
    }
    const { activeSchoolId } = this.props.user;
    return searchFunctionSchoolFormsPublic(text, activeSchoolId);
  };

  getSchoolHouses = (text: string, setFieldValue) => {
    if (text === '') {
      setFieldValue('houseId', '');
      setFieldValue('house', undefined);
      this.setState({ houseId: '' });
    }

    const { activeSchoolId } = this.props.user;
    return searchFunctionSchoolHousesPublic(text, activeSchoolId);
  };

  render() {
    const { firstName, lastName } = this.props.request.requester;
    const isStudent = this.props.request.requestedPermission.preset === ROLE.STUDENT;

    const userForm = {
      user: undefined,
      userId: '',
      form: undefined,
      formId: this.state.formId,
      house: undefined,
      houseId: this.state.houseId
    };

    return (
      <Formik
        initialValues={userForm}
        onSubmit={values => {
          this.props.onAcceptClick(values);
        }}
      >
        {({ values, setFieldValue }) => (
          <Form className="requestMergeForm">
            <div className="requestMergeForm__head">
              <div className="requestActionModal__icon">M</div>
              <div>
                <h5>Merge user</h5>
                <p>
                  Choose the existing user to merge with the request for {firstName} {lastName}.
                </p>
              </div>
            </div>

            {isStudent && (
              <div className="requestMergeForm__grid requestMergeForm__grid--two">
                <label className="requestMergeForm__field">
                  <span>Form</span>
                  <Field name="form">
                    {() => (
                      <Autocomplete
                        searchFunction={text => this.getSchoolForms(text, setFieldValue)}
                        getElementTitle={getName}
                        customClass="requestMergeForm__autocomplete"
                        defaultItem={values.form}
                        onSelect={form => {
                          setFieldValue('formId', form.id);
                          setFieldValue('form', form);
                          this.setState({ formId: form.id });
                        }}
                      />
                    )}
                  </Field>
                </label>

                <label className="requestMergeForm__field">
                  <span>House</span>
                  <Field name="house">
                    {() => (
                      <Autocomplete
                        searchFunction={text => this.getSchoolHouses(text, setFieldValue)}
                        getElementTitle={getName}
                        customClass="requestMergeForm__autocomplete"
                        defaultItem={values.house}
                        onSelect={house => {
                          setFieldValue('houseId', house.id);
                          setFieldValue('house', house);
                          this.setState({ houseId: house.id });
                        }}
                      />
                    )}
                  </Field>
                </label>
              </div>
            )}

            <label className="requestMergeForm__field">
              <span>Existing user</span>
              <Field name="userId">
                {() => (
                  <Autocomplete
                    searchFunction={text => this.getUser(text, setFieldValue)}
                    getElementTitle={getFullName}
                    customClass="requestMergeForm__autocomplete"
                    defaultItem={values.user}
                    onSelect={user => {
                      setFieldValue('user', user);
                      setFieldValue('userId', user.id);
                    }}
                  />
                )}
              </Field>
            </label>

            <div className="requestMergeForm__foot">
              <button type="button" className="people-btn people-btn--secondary" onClick={this.props.onCloseClick}>
                Cancel
              </button>
              <button
                type="submit"
                className="people-btn people-btn--primary"
                disabled={typeof values.user === 'undefined' || values.userId === ''}
              >
                Merge user
              </button>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}
